import { inject } from "@angular/core";
import { IConfig as UnleashConfig } from "unleash-proxy-client";

import packageInfo from "../../../../package.json";
import { AppConfig } from "environments/environment";

import { UnleashStorageProviderService } from "../services/unleash-storage-provider.service";

export const unleashConfigFactory = (): UnleashConfig => {
  const storageProvider = inject(UnleashStorageProviderService);

  const UNLEASH_PROXY_URL = "https://ff.inseer.com/api/frontend/";

  return {
    appName: packageInfo.name,
    environment: AppConfig.environment.toLowerCase(),
    url: UNLEASH_PROXY_URL,
    clientKey: process.env.UNLEASH_API_KEY ?? "",
    storageProvider,
  };
};
